import React, { useEffect, useState } from "react";
import { useAsyncAxios, utilAxiosWithAuth } from "../../utils/customAxios";
import { Button, Col, Divider, Modal, Row, Space } from "antd";
import { ColumnsType } from "antd/lib/table";

import * as Request from "../../commons/request";
import * as Types from "../../commons/typeDTO";
import * as String from "../../commons/string";
import * as Utils from "../../utils/utils";

import DataTable from "../../components/DataTable";
import RentCarDetail from "../../components/RentCarDetail";
import { AlertType, useAlert } from "../../provider/AlertProvider";

function RentCarManagement() {
    const alert = useAlert();
    const [rentCars, setRentCars] = useState<Array<Types.RentCarDto>>([]);
    const [currentRentCar, setCurrentRentCar] = useState<Types.RentCarDto>();

    const [editMode, setEditMode] = useState<string>("none");
    const [openDeleteRentCar, setOpenDeleteRentCar] = useState(false);

    const convertCurrency = (price: number | undefined) => {
        if (price === undefined) return String.dash;
        return Utils.convertCurrencyKorean(price);
    };

    useEffect(() => {
        requestGetRentCars();
    }, []);

    //get rentCars
    const requestAxiosGetRentCars = async () => {
        const response = await utilAxiosWithAuth().get(Request.RENT_CARS_ALL_URL, { params: { getAll: true } });
        return response.data;
    };

    const {
        loading: loadingGetRentCars,
        error: errorGetRentCars,
        data: resultGetRentCars,
        execute: requestGetRentCars,
    } = useAsyncAxios(requestAxiosGetRentCars);

    useEffect(() => {
        if (resultGetRentCars === null) return;

        console.log("resultGetRentCars", resultGetRentCars);
        setRentCars(resultGetRentCars.rentCars);
    }, [resultGetRentCars]);

    useEffect(() => {
        if (errorGetRentCars === null) return;
        console.log("errorGetRentCars", errorGetRentCars);
    }, [errorGetRentCars]);

    //register rentCar
    const requestAxiosRegisterRentCar = async (car: Types.RentCarDto) => {
        const response = await utilAxiosWithAuth().post(Request.RENT_CAR_ADD_URL, car);
        return response.data;
    };

    const {
        loading: loadingRegisterRentCar,
        error: errorRegisterRentCar,
        data: resultRegisterRentCar,
        execute: requestRegisterRentCar,
    } = useAsyncAxios(requestAxiosRegisterRentCar);

    useEffect(() => {
        if (resultRegisterRentCar === null) return;
        console.log("resultRegisterRentCar", resultRegisterRentCar);

        requestGetRentCars();
        setCurrentRentCar(resultRegisterRentCar.rentCar);
        alert.setAlert(AlertType.SUCCESS, "렌트차량 등록 성공", "렌트차량 등록을 완료하였습니다.");
    }, [resultRegisterRentCar]);

    useEffect(() => {
        if (errorRegisterRentCar === null) return;
        console.log("errorRegisterRentCar", errorRegisterRentCar);
    }, [errorRegisterRentCar]);

    //update rentCar
    const requestAxiosUpdateRentCar = async (rentCarId: number, data: Types.RentCarDto) => {
        const response = await utilAxiosWithAuth().put(Request.RENT_CAR_URL + rentCarId, data);
        return response.data;
    };
    const {
        loading: loadingUpdateRentCar,
        error: errorUpdateRentCar,
        data: resultUpdateRentCar,
        execute: requestUpdateRentCar,
    } = useAsyncAxios(requestAxiosUpdateRentCar);

    useEffect(() => {
        if (resultUpdateRentCar === null) return;

        requestGetRentCars();
        setCurrentRentCar(resultUpdateRentCar.rentCar);
        alert.setAlert(AlertType.SUCCESS, "렌트차량 수정 성공", "렌트차량 수정을 완료하였습니다.");
    }, [resultUpdateRentCar]);

    useEffect(() => {
        if (errorUpdateRentCar === null) return;
        console.log("errorUpdateRentCar", errorUpdateRentCar);
    }, [errorUpdateRentCar]);

    //delete rentCar
    const requestAxiosDeleteRentCar = async (rentCarId: number) => {
        const response = await utilAxiosWithAuth().delete(Request.RENT_CAR_URL + rentCarId);
        return response.data;
    };
    const {
        loading: loadingDeleteRentCar,
        error: errorDeleteRentCar,
        data: resultDeleteRentCar,
        execute: requestDeleteRentCar,
    } = useAsyncAxios(requestAxiosDeleteRentCar);

    useEffect(() => {
        if (resultDeleteRentCar === null) return;
        console.log("resultDeleteRentCar", resultDeleteRentCar);

        setOpenDeleteRentCar(false);
        requestGetRentCars();
        setCurrentRentCar(undefined);

        alert.setAlert(AlertType.SUCCESS, "렌트차량 삭제 성공", "렌트차량 삭제를 완료하였습니다.");
    }, [resultDeleteRentCar]);

    useEffect(() => {
        if (errorDeleteRentCar === null) return;
        console.log("errorDeleteRentCar", errorDeleteRentCar);
    }, [errorDeleteRentCar]);

    const columns: ColumnsType<Types.RentCarDto> = [
        {
            align: "center",
            title: "번호",
            dataIndex: "num",
            key: "rentId",
            render: (item, record, index) => <>{rentCars && rentCars.indexOf(record) + 1}</>,
        },
        {
            align: "center",
            title: "차량타입",
            dataIndex: "carType",
            key: "carType",
            sorter: (a, b, sortOrder) => Utils.sortString(a?.car?.carType?.typeName.valueOf(), b?.car?.carType?.typeName.valueOf(), sortOrder),
            render: (_, row) => {
                if (row.car?.carType?.typeName) {
                    return row.car?.carType?.typeName;
                } else return String.dash;
            },
        },
        {
            align: "center",
            title: "차량번호",
            dataIndex: "carNumber",
            key: "carNumber",
            sorter: (a, b, sortOrder) => Utils.sortString(a.car.carNumber.valueOf(), b.car.carNumber.valueOf(), sortOrder),
            render: (_, row) => {
                if (row.car?.carNumber) {
                    return row.car?.carNumber;
                } else return String.dash;
            },
        },
        {
            align: "center",
            title: "가격",
            dataIndex: "price",
            key: "price",
            sorter: (a, b, sortOrder) => Utils.sortString(a.price.toString().valueOf(), b.price.toString().valueOf(), sortOrder),
            render: (_, row) => {
                if (row.price) {
                    return convertCurrency(row.price);
                } else return String.dash;
            },
        },
        {
            align: "center",
            title: "할인가",
            dataIndex: "discountPrice",
            key: "discountPrice",
            sorter: (a, b, sortOrder) => Utils.sortString(a.discountPrice.toString().valueOf(), b.discountPrice.toString().valueOf(), sortOrder),
            render: (_, row) => {
                if (row.discountPrice) {
                    return convertCurrency(row.discountPrice);
                } else return String.dash;
            },
        },
        {
            align: "center",
            title: "주말가격",
            dataIndex: "weekendPrice",
            key: "weekendPrice",
            sorter: (a, b, sortOrder) => Utils.sortString(a.weekendPrice.toString().valueOf(), b.weekendPrice.toString().valueOf(), sortOrder),
            render: (_, row) => {
                if (row.weekendPrice) {
                    return convertCurrency(row.weekendPrice);
                } else return String.dash;
            },
        },
        {
            align: "center",
            title: "주말할인가",
            dataIndex: "weekendDiscountPrice",
            key: "weekendDiscountPrice",
            sorter: (a, b, sortOrder) => Utils.sortString(a.weekendDiscountPrice.toString().valueOf(), b.weekendDiscountPrice.toString().valueOf(), sortOrder),
            render: (_, row) => {
                if (row.weekendDiscountPrice) {
                    return convertCurrency(row.weekendDiscountPrice);
                } else return String.dash;
            },
        },
        {
            align: "center",
            title: "차고지",
            dataIndex: "region",
            key: "region",
            sorter: (a, b, sortOrder) => Utils.sortString(a.rentRegion.rentRegionName.toString(), b.rentRegion.rentRegionName.toString(), sortOrder),
            render: (_, row) => {
                if (row.rentRegion?.rentRegionName) {
                    return row.rentRegion.rentRegionName;
                } else return String.dash;
            },
        },
        {
            align: "center",
            title: "운행",
            dataIndex: "unavailable",
            key: "unavailable",
            render: (_, row) => {
                if (row.unavailable === true) {
                    return "불가능";
                } else return "가능";
            },
        },
        {
            align: "center",
            title: "대기",
            dataIndex: "waiting",
            key: "waiting",
            render: (_, row) => {
                if (row.waiting === true) {
                    return "대기";
                } else return String.dash;
            },
        },
        {
            align: "center",
            title: "점검",
            dataIndex: "repairing",
            key: "repairing",
            render: (_, row) => {
                if (row.repairing === true) {
                    return "점검중";
                } else return String.dash;
            },
        },
        {
            align: "center",
            title: " ",
            dataIndex: "action",
            key: "action",
            render: (_, row) => {
                return (
                    <>
                        <Button
                            shape="round"
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                setCurrentRentCar(row);
                                setEditMode("update");
                            }}
                        >
                            {String.update}
                        </Button>
                        <Button
                            shape="round"
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                setCurrentRentCar(row);
                                setOpenDeleteRentCar(true);
                            }}
                        >
                            {String.remove}
                        </Button>
                    </>
                );
            },
        },
    ];

    const onChangeRentCar = (car: any) => {
        car.rentRestrictions = car?.rentRestrictions?.map((id: number) => ({ rentRestrictionId: id }));
        car.rentOptions = car?.rentOptions?.map((id: number) => ({ rentOptionId: id }));

        if (editMode === "add") {
            requestRegisterRentCar(car);
        } else if (editMode === "update") {
            requestUpdateRentCar(car.rentCarId, car);
        }
    };

    const handleDeleteRentCarOk = () => {
        requestDeleteRentCar(currentRentCar?.rentCarId);
    };

    const handleDeleteRentCarCancel = () => {
        setOpenDeleteRentCar(false);
    };

    return (
        <div className="container">
            <Space size={30} direction="vertical" style={{ width: "100%" }}>
                <h3 className="title">차량 관리</h3>
                <div>
                    <Row justify={"space-between"}>
                        <Col span={6}>
                            <Divider orientation="left">
                                <span>차량</span>
                            </Divider>
                        </Col>
                        <Space>
                            <Button
                                onClick={() => {
                                    setCurrentRentCar(undefined);
                                    setEditMode("add");
                                }}
                            >
                                {String.userAdd}
                            </Button>
                        </Space>
                    </Row>
                    <DataTable rowKey={(row: Types.RentCarDto) => row.rentCarId} hasScroll={false} columns={columns} dataSource={rentCars} />
                </div>
            </Space>
            {editMode !== "none" && (
                <RentCarDetail
                    editMode={editMode}
                    rentCarIds={rentCars.map((car) => car?.car?.carId)}
                    rentCar={currentRentCar}
                    onChangeRentCar={onChangeRentCar}
                />
            )}
            {openDeleteRentCar && (
                <Modal open={openDeleteRentCar} onOk={handleDeleteRentCarOk} onCancel={handleDeleteRentCarCancel}>
                    {currentRentCar?.car.carNumber} 삭제하시겠습니까?
                </Modal>
            )}
        </div>
    );
}

export default RentCarManagement;
